export default __webpack_public_path__ + "static/media/content-img-4.4d172274.jpg";